<template>
  <div class="page-container" :class="{ 'dark-background': dark }">
    <div class="content-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  dark: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.page-container {
  position: relative;
  width: 100dvw;
  min-height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 4.063rem;
  box-sizing: border-box;
}

.dark-background {
  background-color: var(--color-bg-dark);
}

.content-wrapper {
  position: relative;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 87.5rem;
  margin: 0 auto;
}

@media (max-width: 64rem) {
  .page-container {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}

@media (max-width: 48rem) {
  .page-container {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
</style>
